import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconLocation(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fillRule="evenodd"
        d="M12 2C8.085 2 5 5.313 5 9.3c0 1.375.431 2.84 1.018 4.215.592 1.387 1.373 2.753 2.14 3.948a42.777 42.777 0 0 0 2.113 2.986l.008.01c.542.701 1.093 1.414 1.721 2.042.5-.5.937-1.028 1.729-2.052a42.793 42.793 0 0 0 2.112-2.986c.768-1.195 1.55-2.561 2.141-3.948C18.57 12.14 19 10.675 19 9.3 19 5.312 15.915 2 12 2ZM9.841 16.383A40.953 40.953 0 0 0 12 19.414a40.95 40.95 0 0 0 2.159-3.032c.732-1.139 1.45-2.403 1.984-3.652.538-1.262.857-2.44.857-3.43C17 6.325 14.72 4 12 4S7 6.325 7 9.3c0 .99.319 2.168.857 3.43.533 1.25 1.252 2.513 1.984 3.652ZM11 9.001a1 1 0 1 1 2.001.001A1 1 0 0 1 11 9.001Zm1-3a3 3 0 1 0 .001 6.001A3 3 0 0 0 12 6.001Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
